import { IScope, IWindowService } from "angular";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";

import { parseJSON } from "date-fns";
import { GeneralService } from "../../services/general.service";
import { BetService } from "../../services/bet.service";
import { Match } from "../../interfaces/match.interface";


export class BettingActionBannerController {
	
	awayBeforeHome = false;
	bestBetError = false;
	bestParlayUnavailable = false;
	betService: BetService;
	betType: string;
	displayMaximumWidths = {
		"x-compact": 350,
		"compact": 500,
		"less-compact": 600,
		"medium": 700,
		"large": 800,
	};
	displayMode = "full";
	gamesError = false;
	gamesLoading = true;
	generalService: GeneralService;
	match: Match = null;
	showBestParlay = false;
	_$scope: IScope;
	// _Rollbar: any;
	_$window: IWindowService;
	configurationObject: BlockConfigurationObject;
	matchService: MatchService;
	sportDataService: SportDataService;
	bannerLoading = true;
	bannerError = false;

	betString = "";
	oddsString = "";
	desktopButtonString = "";
	mobileButtonString = "";

	/* @ngInject */
	constructor($scope: IScope, /*Rollbar: any,*/ $window: IWindowService, configurationObject: BlockConfigurationObject,
		matchService: MatchService, sportDataService: SportDataService, generalService: GeneralService, betService: BetService, public cdnDomain: string) {
		this._$scope = $scope;
		// this._Rollbar = Rollbar;
		this._$window = $window;
		this.configurationObject = configurationObject;
		this.matchService = matchService;
		this.sportDataService = sportDataService;
		this.generalService = generalService;
		this.betService = betService;

		this.betType = configurationObject.betType;


		
		generalService.initialiseBlock();
		if (!this.betType) {
			this.betType = "overall";
		}

		if (!configurationObject.matchFirstTeam || configurationObject.matchFirstTeam === "away") {
			this.awayBeforeHome = true;
		}

		Object.keys(this.displayMaximumWidths).forEach(level => {
			if ($window.document.getElementById(configurationObject.targetElementID)
				&& $window.document.getElementById(configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				this.displayMode += ` ${level}`;
			}
		});

		$window.addEventListener("resize", this.checkCompact);

		matchService.getGeoData().then(() => {
			this.processBanner(configurationObject);
		}, () => {
			this.processBanner(configurationObject);
		});
	}

	checkCompact = (): void => {
		let modeString = "full";
		Object.keys(this.displayMaximumWidths).forEach(level => {
			if (this._$window.document.getElementById(this.configurationObject.targetElementID)
				&& this._$window.document.getElementById(this.configurationObject.targetElementID).offsetWidth <= this.displayMaximumWidths[level]) {
				modeString += ` ${level}`;
			}
		});

		this._$scope.$apply(() => {
			this.displayMode = modeString;
		});
	}

	prepareMatchData = (): void => {
		this.match.MatchData.UserDate = parseJSON(this.match.MatchData.Date);

		if (this.betType !== "overall") {
			if (this.betType === "parlay") {
				this.showBestParlay = true;
				if (this.bestParlayUnavailable) {
					this.bestBetError = true;
				}
			} else {
				this.match.aggregatedBestBets = this.match.aggregatedBestBets.filter(b => b.type === this.betType);
				if (this.match.aggregatedBestBets.length === 0) {
					this.bestBetError = true;
				}
			}
		} else {
			this.match.aggregatedBestBets = this.match.aggregatedBestBets.sort((a,b) => b.edge - a.edge);
			if (this.match.aggregatedBestBets.length === 0) {
				this.bestBetError = true;
			}
		}

		this.gamesLoading = false;
	}

	processBanner = (c: BlockConfigurationObject): void => {
		this.bannerLoading = true;
		this.bannerError = false;
		let payout: number;

		if (!c.stake) {
			c.stake = 20;
		}

		// if both override bet string and (one of override button text or override odds) are provided, matchID is not required
		// otherwise, matchID, bookmakers, desktopImageURL, desktopImageAltText, mobileImageURL and mobileImageAltText are all required
		if (c.overrideBetString && (c.overrideOdds || c.overrideButtonText)) {

			if (!c.bookmaker) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: bookmaker not provided`);
				this.bannerError = true;
			} else if (!c.desktopImageURL) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: desktop image URL not provided`);
				this.bannerError = true;
			} else if (!c.desktopImageAltText) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: desktop image alt text not provided`);
				this.bannerError = true;
			} else if (!c.mobileImageURL) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: mobile image URL not provided`);
				this.bannerError = true;
			} else if (!c.mobileImageAltText) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: mobile image alt text not provided`);
				this.bannerError = true;
			} else {

				// catch for URLs on old CDN: change https://statsinsider-wwwbeta.azureedge.net/static/* to [cdn domain variable]/*
				c.desktopImageURL = c.desktopImageURL.replace("https://statsinsider-wwwbeta.azureedge.net/static/", this.cdnDomain + "/");
				c.mobileImageURL = c.mobileImageURL.replace("https://statsinsider-wwwbeta.azureedge.net/static/", this.cdnDomain + "/");

				this.betString = c.overrideBetString;
				if (c.overrideOdds) {
					this.oddsString = this.betService.formatOdds(c.overrideOdds);
				}
				if (c.overrideButtonText) {
					this.desktopButtonString = c.overrideButtonText;
					this.mobileButtonString = c.overrideButtonText;
				} else {
					payout = c.stake * c.overrideOdds;
					this.desktopButtonString = `Bet $${Number.isInteger(c.stake) ? c.stake : c.stake.toFixed(2)}<br/>Payout $${Number.isInteger(payout) ? payout : payout.toFixed(2)}`;
					this.mobileButtonString = `Bet $${Number.isInteger(c.stake) ? c.stake : c.stake.toFixed(2)}, Payout $${Number.isInteger(payout) ? payout : payout.toFixed(2)}`;
				}

				this.bannerLoading = false;
				this._$scope.$apply();
			}
		} else {
			if (!c.bookmaker) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: bookmaker not provided`);
				this.bannerError = true;
			} else if (!c.matchID) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: neither match ID nor override parameter pair provided`);
				this.bannerError = true;
			} else if (!c.desktopImageURL) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: desktop image URL not provided`);
				this.bannerError = true;
			} else if (!c.desktopImageAltText) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: desktop image alt text not provided`);
				this.bannerError = true;
			} else if (!c.mobileImageURL) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: mobile image URL not provided`);
				this.bannerError = true;
			} else if (!c.mobileImageAltText) {
				console.error(`Betting Action Banner error on element #${c.targetElementID}: mobile image alt text not provided`);
				this.bannerError = true;
			} else {

				// catch for URLs on old CDN: change https://statsinsider-wwwbeta.azureedge.net/static/* to [cdn domain variable]/*
				c.desktopImageURL = c.desktopImageURL.replace("https://statsinsider-wwwbeta.azureedge.net/static/", this.cdnDomain + "/");
				c.mobileImageURL = c.mobileImageURL.replace("https://statsinsider-wwwbeta.azureedge.net/static/", this.cdnDomain + "/");
				
				if (!c.market) {
					c.market = "h2h";
				}

				if (!["h2h", "line", "total"].includes(c.market)) {
					console.warn(`Betting Action Banner warning on element #${c.targetElementID}: market type ${c.market} is not valid. Defaulting to h2h`);
					c.market = "h2h";
				}

				if (!c.bet) {
					if (c.market === "total") {
						c.bet = "over";
					} else {
						c.bet = "home";
					}
				}

				if (c.market === "total") {
					if (!["over", "under"].includes(c.bet)) {
						console.warn(`Betting Action Banner warning on element #${c.targetElementID}: bet type ${c.bet} is not valid for market type ${c.market}. Defaulting to over`);
						c.bet = "over";
					}
				} else {
					if (!["home", "away"].includes(c.bet)) {
						console.warn(`Betting Action Banner warning on element #${c.targetElementID}: bet type ${c.bet} is not valid for market type ${c.market}. Defaulting to home`);
						c.bet = "home";
					}
				}

				this.sportDataService.getPreMatchData(c.matchID, true, [c.bookmaker])
					.then(match => {
						if (!match || !match.aggregatedBettingInfo) {
							console.error(`Betting Action Banner error on element #${c.targetElementID}: betting data not found for bookmaker ${c.bookmaker} on match ${c.matchID}`);
							this.bannerError = true;
						} else {
							let targetOdds;
							if (c.market === "h2h") {
								targetOdds = c.bet === "home" ? match.aggregatedBettingInfo.HomeOdds : match.aggregatedBettingInfo.AwayOdds;
							} else if (c.market === "line") {
								targetOdds = c.bet === "home" ? match.aggregatedBettingInfo.HomeLineOdds : match.aggregatedBettingInfo.AwayLineOdds;
							} else {
								targetOdds = c.bet === "over" ? match.aggregatedBettingInfo.OverOdds : match.aggregatedBettingInfo.UnderOdds;
							}

							if (!targetOdds) {
								console.error(`Betting Action Banner error on element #${c.targetElementID}: ${c.market} ${c.bet} odds not found for ${c.bookmaker} on match ${c.matchID}`);
								this.bannerError = true;
							} else if ((c.market === "total" && !match.aggregatedBettingInfo.TotalLine)) {
								console.error(`Betting Action Banner error on element #${c.targetElementID}: total mark not found for ${c.bookmaker} on match ${c.matchID}`);
								this.bannerError = true;
							} else {
								this.oddsString = this.betService.formatOdds(targetOdds);

								if (c.overrideButtonText) {
									this.desktopButtonString = c.overrideButtonText;
									this.mobileButtonString = c.overrideButtonText;
								} else {
									payout = targetOdds * c.stake;
									this.desktopButtonString = `Bet $${Number.isInteger(c.stake) ? c.stake : c.stake.toFixed(2)}<br/>Payout $${Number.isInteger(payout) ? payout : payout.toFixed(2)}`;
									this.mobileButtonString = `Bet $${Number.isInteger(c.stake) ? c.stake : c.stake.toFixed(2)}, Payout $${Number.isInteger(payout) ? payout : payout.toFixed(2)}`;
								}
								

								if (c.market === "h2h") {
									this.betString = `${(c.bet === "home" ? match.MatchData.HomeTeam : match.MatchData.AwayTeam).DisplayName} ML vs. ${
										(c.bet === "home" ? match.MatchData.AwayTeam : match.MatchData.HomeTeam).DisplayName}`;
								} else if (c.market === "line") {
									if (c.bet === "home") {
										this.betString = `${match.MatchData.HomeTeam.DisplayName} (${
											match.aggregatedBettingInfo.HomeLine > 0 ? "+" : ""}${match.aggregatedBettingInfo.HomeLine}) vs. ${
											match.MatchData.AwayTeam.DisplayName}`;
									} else {
										this.betString = `${match.MatchData.AwayTeam.DisplayName} (${
											match.aggregatedBettingInfo.HomeLine < 0 ? "+" : ""}${match.aggregatedBettingInfo.HomeLine * -1}) vs. ${
											match.MatchData.HomeTeam.DisplayName}`;
									}
								} else {
									this.betString = `${match.MatchData.AwayTeam.DisplayName}-${match.MatchData.HomeTeam.DisplayName} ${
										c.bet === "over" ? "Over" : "Under"} ${match.aggregatedBettingInfo.TotalLine}`;
								}

								this.bannerLoading = false;
								this._$scope.$apply();
							}
						}
					}, (err) => {
						console.error(`Betting Action Banner error on element #${c.targetElementID}: Failed to retrieve match data for match ${c.matchID}:`);
						console.error(err);
						this.bannerError = true;
					});

			}
		}

		
	}

	reloadBanner = (): void => {
		// call to retrieveSingleGame has to be within Promise due to $scope.$apply calls within, which cause issues if called on the main thread
		Promise.resolve(true).then(() => {
			this.processBanner(this.configurationObject);
		});
	}
}